import { Layout } from '../../../components/Layout'
import { HeadingPages } from '../../../components/HeadingPages'
import { useQuery } from 'react-query'
import { api } from '../../../services/api'
import { Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react'
import { Row } from './Row'


async function approveCurriculo() {}

async function getCurriculoVendedores() {
  try {
    const response = await api.get('/site/v2/crm-controle/listagem-curriculos') 

    return response.data
  } catch (error) {
    throw new Error(error)
  }
}

export function CurriculosVendedores() {
  const { data, isLoading } = useQuery({
    queryKey: 'curriculos-vendedores',
    queryFn: getCurriculoVendedores,
  })


  return (
    <>
      <HeadingPages name="Currículo de Vendedores" />
      <Layout>
        {isLoading ? (
          <p>Carregando...</p>
        ) : (
         <TableContainer>
          <Table
            variant="simple"
            size="sm"
            colorScheme="blackAlpha"
            borderWidth="1px"
            borderRadius="md"
          >
            <Thead>
              <Tr>
                <Th>Data de envio</Th>
                <Th>Nome</Th>
                <Th>Telefone</Th>
                <Th>Email</Th>
                <Th>Curriculo</Th>
                <Th></Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.map((curriculo) => (
                <Row key={curriculo.id} curriculo={curriculo} />
              ))}
            </Tbody>
          </Table>
         </TableContainer>
        )
        }

      </Layout>
    </>
  )
}